import { render, staticRenderFns } from "./_author.vue?vue&type=template&id=21ecff5c&scoped=true&"
import script from "./_author.vue?vue&type=script&lang=js&"
export * from "./_author.vue?vue&type=script&lang=js&"
import style0 from "./_author.vue?vue&type=style&index=0&id=21ecff5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/nuxt/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ecff5c",
  null
  
)

export default component.exports